/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { observer } from "mobx-react";
import { Layout } from "antd";
import { AlignRightOutlined } from "@ant-design/icons";
import { useParams, useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";

import "../fields.less";
import { pageWrapper } from "../../../utils";
import { AttributeModal, FieldsTable } from "../components";
import { useLocale, useStore } from "../../../hooks";
import { FIELDS } from "../../../constants";

const { Content } = Layout;

const AttributesListPage = () => {
  const { FieldsStore } = useStore();
  const { push } = useHistory();
  const { id } = useParams();
  const { search } = useLocation();
  const { category } = queryString.parse(search);
  const { data, parent } = FieldsStore.getAttributes(id, category);
  const t = useLocale("fields/list");
  const tForm = useLocale("fields/form");

  return (
    <Content className="fields">
      <AttributeModal
        title={
          FieldsStore.editMode
            ? tForm("attributes.titles.edit")
            : tForm("attributes.titles.add")
        }
        data={data}
      />
      <FieldsTable
        data={data}
        sortData={(...params) => parent.sortData(...params, "attributes")}
        buttonText={t("attributes.addButton")}
        buttonAction={() =>
          FieldsStore.toggleModal(
            "attribute",
            FIELDS.attribute.defaultFormValues,
            false
          )
        }
        columns={[
          {
            title: t("attributes.table.headings.title"),
            dataIndex: "title",
            className: "drag-visible",
          },
          {
            title: t("attributes.table.headings.type"),
            dataIndex: "type",
          },
        ]}
        actions={[
          {
            title: t("attributes.table.fields.options"),
            icon: <AlignRightOutlined />,
            onClick: ({ key }) => {
              push(
                `/fields/options/${key}?type=attributes&category=${
                  category || id
                }&subcat=${category ? id : ""}`
              );
            },
          },
        ]}
      />
    </Content>
  );
};

const AttributesList = pageWrapper(observer(AttributesListPage), {
  hasHeader: true,
  get subTitle() {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useLocale("fields/list")("attributes.description");
  },
});

export { AttributesList };
